<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6ndPld/cover.jpeg?1684255618578" alt="This image is the cover for the book Soul Healer, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Soul Healer, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p><strong>Everyone had long since gotten tired of seeing an amorous ghost girl chat with a weak scholar. If that was the case, when Taoist Gao Leng met with a ghost of amnesia, what kind of love and hate conflicts would occur between them!</strong></p><p>Once, you were a ghost and I was Daoist Ling Xu. Even after using all my strength, I was still unable to become the peerless hero in your heart.</p><p>Now that you're a puppet, and I'm a spirit doctor, I'll protect you no matter what. The Road to River Styx, the Three Way River, the Resurrection Lily, if fate wills it, I'll accompany you ….</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        An DongNi, Babel Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33c4d243